import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import mainbanner from '../assests/img/sbse-top-banner-new.jpeg';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

import Slider from "react-slick";


function App() {
  const [newsList, setNewsList] = useState([]);
  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };


  useEffect(() => {
  fetch("https://sbsedelhi.com/backend/wp-json/custom/v1/news-updates")
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) {
        setNewsList(data);
      }
    })
    .catch(err => console.error(err));
}, []);


  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
  
    const handleChange = e => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };
  
    const handleSubmit = async e => {
      e.preventDefault();
      setLoading(true);
      setSuccess('');
      setError('');
      try {
        // POST to your backend API that sends emails to admin and user
        const response = await fetch('https://sbsedelhi.com/backend/wp-json/custom/v1/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(form)
  });
        if (!response.ok) throw new Error('Failed to send message');
        setSuccess('Your message has been sent!');
        setForm({ name: '', email: '', message: '' });
      } catch (err) {
        setError('Failed to send message.');
      } finally {
        setLoading(false);
      }
    };

return (
  <div style={{ background: '#ffffff', minHeight: '100vh' }}>
    <Helmet>
      <title>State Board of Secondary Education, Delhi</title>
      <meta name="description" content="State Board of Secondary Education, Delhi - Official Website" />
      <meta name="keywords" content="State Board of Secondary Education, Delhi, education, literacy, initiatives" />
    </Helmet>
    <Header />

 <div className='container d-none'>
  <div
    className='news-updates-bar'
    style={{
      background: '#ffffff',
      color: '#007bff',
      padding: '8px 0',
      textAlign: 'center',
      fontSize: 16,
      border: '1px solid #007bff',
      fontWeight: 500
    }}
  >
    <marquee behavior="scroll" direction="left">
      {newsList.length > 0
        ? newsList.map((item, i) => (
            <div
              key={item.id || i}
              style={{ display: 'inline-block', marginRight: 40 }}
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          ))
        : "No updates available"}
    </marquee>
  </div>
</div>


    <div className='container' style={{ paddingTop: 32, paddingBottom: 32 }}>
      <div className='row' style={{ display: 'flex'}}>
        <div className='col-md-8' style={{ background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px #e0e0e0', padding: 32, marginBottom: 0 }}>
          <div className='main-slider' style={{ marginBottom: 32 }}>
            <Slider {...settings}>
              <div>
                <img src={mainbanner} style={{ width: '100%', borderRadius: 12, maxHeight: 340, objectFit: 'cover', boxShadow: '0 2px 12px #e0e0e0' }} alt="Main Banner" />
              </div>
              <div>
                <img src={mainbanner} style={{ width: '100%', borderRadius: 12, maxHeight: 340, objectFit: 'cover', boxShadow: '0 2px 12px #e0e0e0' }} alt="Main Banner" />
              </div>
            </Slider>
          </div>
          <div className="welcome-text" style={{ fontSize: 18, color: '#333', lineHeight: 1.7 }}>
            <p style={{ marginBottom: 24 }}>
              Dear Visitor, welcome to our website. The website, which contains all important information regarding eligibility for admission, admission procedure, courses offered, duration of the various courses, teaching faculty counseling schedule, fee structure, rules and regulations, and library and other support services, will provide answers to all your questions about the STATE BOARD OF SECONDARY EDUCATION, DELHI. In case, you wish to have more information or need any clarification, please contact our 'helpline numbers' given on this website. We are committed to help you.
            </p>
            <div style={{ background: '#eaf4ff', borderRadius: 12, padding: 24, marginBottom: 24, boxShadow: '0 1px 8px #e0e0e0' }}>
              <div className='row'>
                <div className='col-md-3' style={{ textAlign: 'left', padding: 16 }}>
                  <a target="_blank" rel="noopener noreferrer" href="http://www.iao.org/IAO/MemberArea/Accreditation-Profile.aspx?ec=89139">
                <img className="img-responsive iao-logo" src="https://sbsedelhi.com/backend/wp-content/themes/twentythirteen/images/iao-logo.jpg" style={{ maxWidth: 180, marginBottom: 16, borderRadius: 8, boxShadow: '0 1px 8px #e0e0e0' }} alt="IAO Logo" />
              </a>

                </div>
                  <div className='col-md-9' style={{ textAlign: 'left', padding: 16 }}>
                      <h2 style={{ color: '#007bff', fontWeight: 700, marginBottom: 16 }}>Accreditation</h2>
                   <p style={{ fontSize: 16, color: '#333' }}>
                STATE BOARD OF SECONDARY EDUCATION, DELHI has successfully met all of the IAO's accreditation requirements and as a result has been awarded Full accreditation by IAO. The institute has been awarded Full Accreditation after evaluation it on IAO standards of the global best practices in Organizational Management, Academic Management and Institutional Performance. IAO's full accreditation is a proof that STATE BOARD OF SECONDARY EDUCATION, DELHI offers education to its students that is on par with global education standards and that the institute is fully committed towards continuous improvement of its educational standards.
              </p>
                  </div>
              </div>
            
              
             
            </div>
          </div>
        


        </div>
        <div className='col-md-4 home-sidebar' style={{ minWidth: 320 }}>
          <div className="left-bar-menu d-grid gap-0" style={{ background: '#fff', borderRadius: 16, boxShadow: '0 2px 12px #e0e0e0', padding: 24 }}>
            <Link className='btn btn-primary btn-block' style={{ fontSize: 18, padding: '16px 0', marginBottom: 12, borderRadius: 8, fontWeight: 600 }} to='/universities-letters'>Universities Approval Letters</Link>
            <Link className='btn btn-primary btn-block' style={{ fontSize: 18, padding: '16px 0', marginBottom: 12, borderRadius: 8, fontWeight: 600 }} to='/legalization'>Legalization</Link>
            <Link className='btn btn-primary btn-block' style={{ fontSize: 18, padding: '16px 0', marginBottom: 12, borderRadius: 8, fontWeight: 600 }} to='/download'>Downloads</Link>
            <Link className='btn btn-primary btn-block' style={{ fontSize: 18, padding: '16px 0', marginBottom: 12, borderRadius: 8, fontWeight: 600 }} to='/student-verification'>Student Verification</Link>
            <Link className='btn btn-primary btn-block' style={{ fontSize: 18, padding: '16px 0', marginBottom: 12, borderRadius: 8, fontWeight: 600 }} to='/on-demand-examination'>On Demand Examination</Link>
            <div style={{ background: '#eaf4ff', borderRadius: 12, padding: 20, marginTop: 8, boxShadow: '0 1px 8px #e0e0e0' }}>
              <h4 style={{ color: '#007bff', fontWeight: 700, marginBottom: 16, textAlign: 'center' }}>Student Enquiry</h4>
             <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Name*</label>
                  <input name='name' value={form.name} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Email*</label>
                  <input name='email' type='email' value={form.email} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Phone*</label>
                  <input name='phone' type='tel' value={form.phone} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Subject*</label>
                  <input name='subject' value={form.subject} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontWeight: 500, display: 'block', marginBottom: 6 }}>Message*</label>
                  <textarea name='message' value={form.message} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16, minHeight: 120 }} />
                </div>
                <button type='submit' disabled={loading} style={{ padding: '12px 0', width: '100%', background: '#007bff', color: '#fff', border: 'none', borderRadius: 6, fontSize: 18, fontWeight: 600, cursor: 'pointer' }}>{loading ? 'Sending...' : 'Send Message'}</button>
                {success && <div style={{ color: 'green', marginTop: 16, fontWeight: 500 }}>{success}</div>}
                {error && <div style={{ color: 'red', marginTop: 16, fontWeight: 500 }}>{error}</div>}
              </form>
            </div>
             <Link className='btn btn-primary btn-block' style={{ fontSize: 18, padding: '16px 0', marginTop: 12, marginBottom: 12, borderRadius: 8, fontWeight: 600 }} to='/result'>10th Result</Link>
              <Link className='btn btn-primary btn-block' style={{ fontSize: 18, padding: '16px 0', marginBottom: 12, borderRadius: 8, fontWeight: 600 }} to='/result'>12th Result</Link>

          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
)

}

export default App;
